<template>
    <chooser class="motivation-chooser"
             v-model="innerValue"
             :options="schemeOptions"
             title="What is your main priority?"
             @input="onInput" />
</template>

<script>

import MOTIVATIONS from '@/models/MOTIVATIONS'

import ResourcesHelper from '@/components/resources-helper'
import SpecialistChooser from './specialist-chooser'

/* eslint-disable no-duplicate-imports */
import imgBoth from '../../assets/motivations/both.jpg'
import imgCo2 from '../../assets/motivations/t-co2.jpg'
import imgFuelBill from '../../assets/motivations/fuel-bill.jpg'
import imgNetZero from '../../assets/motivations/net-zero.jpg'
import imgSap from '../../assets/motivations/both.jpg' // TODO: When used in a chooser for real this will need a new image.
import imgSapC from '../../assets/motivations/both.jpg' // TODO: When used in a chooser for real this will need a new image.
/* eslint-enable no-duplicate-imports */

export default {

    mixins: [
        ResourcesHelper,
        SpecialistChooser,
    ],

    computed: {

        /**
         * @returns {Array<ChooserOptionData>}
         */
        allOptions() {
            const motivationResources = this.commonResources.motivations

            /**
             * Build an option for the provided key.
             * @param {string} key
             * @param {string} image
             * @returns {ChooserOptionData}
             */
            function buildOption(key, image) {
                const entry = motivationResources.find(mr => mr.key === key)
                return {
                    text: entry.shortText,
                    value: entry.key,
                    imageUrl: image,
                    selectedMessage: entry.longText,
                }
            }

            return [
                buildOption(MOTIVATIONS.carbonSaving, imgCo2),
                buildOption(MOTIVATIONS.efficiencyImproving, imgBoth),
                buildOption(MOTIVATIONS.fuelBill, imgFuelBill),
                buildOption(MOTIVATIONS.sapScore, imgSap),
                buildOption(MOTIVATIONS.targetNetZero, imgNetZero),
                buildOption(MOTIVATIONS.targetSapC, imgSapC),
            ]
        },

        /**
         * @returns {Array<ChooserOptionData>}
         */
        schemeOptions() {
            return this.allOptions
                .filter(op => this.schemeMotivations.includes(op.value))
        },

        /**
         * @returns {Array<string>}
         */
        schemeMotivations() {
            return this.$scheme.availableMotivations
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-chooser\_motivation-chooser.scss

.motivation-chooser {
    margin-bottom: 1rem !important;

    @include bp-min-wide {
        margin-bottom: 1.5rem !important;
    }
}

</style>
